module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_6.99b39307.png";